export const ReferenceCodeType = {
  BUNDLE: 'Bundle or Discount Code',
  CAMPAIGN: 'Campaign Code', // used for tracking.
  INVALID: 'Invalid' // we added this.
};
